import Link from "next/link";
import Image from "next/image";
import parse, { domToReact, type DOMNode } from "html-react-parser";
import { type PostOrPage } from "@tryghost/content-api";

export const BlogPostContent = ({ post }: { post: PostOrPage }) => {
  return !post?.html ? (
    <div className="mx-auto w-full px-5 pt-[60px]">
      <main className="mb-10 flex flex-wrap justify-between gap-8 pt-5">
        <section className="w-full">
          <div className="gap-2 text-center text-[28px] font-semibold md:text-[32px]">
            Hmm, this post could not be found.
          </div>
          <div className="gap-2 text-center text-[28px] font-semibold text-crayoBlue md:text-[32px]">
            <Link href="/blog">Go back to the blog</Link>
          </div>
        </section>
      </main>
    </div>
  ) : (
    <article className="gap-small mx-auto w-full max-w-screen-lg space-y-9 px-5 pb-12 text-base text-gray-700 md:pb-24">
      <div className="relative mx-auto max-h-72 w-full max-w-2xl overflow-hidden rounded-lg">
        {post?.feature_image && (
          <Image
            priority={true}
            className="-translate-y-10"
            src={post?.feature_image}
            alt={post.slug.replace("-", " ")}
            width={670}
            height={454}
            draggable={false}
          />
        )}
      </div>
      <div className="align-start mx-auto w-full max-w-xl space-y-5 text-start">
        {parse(post.html, options)}
      </div>
    </article>
  );
};

const options = {
  replace: (domNode: DOMNode) => {
    if (domNode.type === "tag") {
      const { name, children } = domNode;
      const jsx = domToReact(children as DOMNode[], options);

      if (name === "p") return <p className="text-[15px] text-gray-800">{jsx}</p>;

      if (name === "h2") return <h2 className="text-2xl font-semibold leading-relaxed">{jsx}</h2>;

      if (name === "h3") return <h3 className="text-xl font-semibold leading-relaxed">{jsx}</h3>;

      if (name === "h4") return <h4 className="text-base font-semibold">{jsx}</h4>;

      if (name === "li")
        return <li className="list-inside list-disc text-[15px] text-gray-800">{jsx}</li>;

      if (name === "a")
        return (
          <a
            href={domNode.attribs.href?.replace(/\?ref=crayo-ai\.ghost\.io/g, "")}
            className="text-[15px] text-blue-500"
          >
            {jsx}
          </a>
        );
    }
  },
};
